import {
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  VStack,
  HStack,
  Text,
  Switch,
  Button,
  ButtonGroup,
  useDisclosure,
  useColorMode,
} from '@chakra-ui/react'
import { Icon } from './Icon'
import { usePreferences } from '../contexts/PreferencesContext'

// Chakra's setColorMode accepts these; 'system' follows the OS. Note: useColorMode().colorMode
// resolves 'system' to 'light'/'dark', so the System button cannot show an active highlight
// (accepted limitation — theme is delegated to Chakra).
const THEME_OPTIONS = ['light', 'dark', 'system'] as const

/** Header gear icon that opens a drawer of client-side cosmetic preferences. */
export const SettingsButton = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { colorMode, setColorMode } = useColorMode()
  const { disableImages, showTestCampaigns, setDisableImages, setShowTestCampaigns } =
    usePreferences()

  return (
    <>
      <IconButton
        aria-label="Settings"
        variant="ghost"
        size="md"
        onClick={onOpen}
        icon={<Icon icon="mdi:cog-outline" height={24} width={24} />}
      />
      <Drawer isOpen={isOpen} placement="right" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>Settings</DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" gap={6}>
              <VStack align="stretch" gap={2}>
                <Text fontWeight="semibold">Theme</Text>
                <ButtonGroup isAttached size="sm">
                  {THEME_OPTIONS.map(option => (
                    <Button
                      key={option}
                      onClick={() => setColorMode(option)}
                      colorScheme={colorMode === option ? 'green' : 'gray'}
                      textTransform="capitalize"
                    >
                      {option}
                    </Button>
                  ))}
                </ButtonGroup>
              </VStack>

              <HStack justify="space-between">
                <Text>Disable images</Text>
                <Switch
                  aria-label="Disable images"
                  isChecked={disableImages}
                  onChange={event => setDisableImages(event.target.checked)}
                />
              </HStack>

              <HStack justify="space-between">
                <Text>Show test campaigns</Text>
                <Switch
                  aria-label="Show test campaigns"
                  isChecked={showTestCampaigns}
                  onChange={event => setShowTestCampaigns(event.target.checked)}
                />
              </HStack>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  )
}
